import {
  UNIVERSITY_WEB_DETAILS_LIST_REQ,
  UNIVERSITY_WEB_DETAILS_LIST_SUCCESS,
  UNIVERSITY_WEB_DETAILS_LIST_FAILED,
  CREATE_UNIVERSITY_WEB_DETAILS_REQ,
  CREATE_UNIVERSITY_WEB_DETAILS_SUCCESS,
  CREATE_UNIVERSITY_WEB_DETAILS_FAILED,
  CREATE_UNIVERSITY_WEB_DETAILS_RESET,
  UPDATE_UNIVERSITY_WEB_DETAILS_REQ,
  UPDATE_UNIVERSITY_WEB_DETAILS_SUCCESS,
  UPDATE_UNIVERSITY_WEB_DETAILS_FAILED,
  UPDATE_UNIVERSITY_WEB_DETAILS_RESET,
  DELETE_UNIVERSITY_WEB_DETAILS_REQ,
  DELETE_UNIVERSITY_WEB_DETAILS_SUCCESS,
  DELETE_UNIVERSITY_WEB_DETAILS_FAILED,
  DELETE_UNIVERSITY_WEB_DETAILS_RESET,
  UNIVERSITY_WEB_DETAILS_SINGLE_REQ,
  UNIVERSITY_WEB_DETAILS_SINGLE_FAILED,
  UNIVERSITY_WEB_DETAILS_SINGLE_SUCCESS,
} from "../Constants/universityWebDetailsConstants";
import axiosConfig from "../Core/axiosConfig";

export const LIST_UNIVERSITY_WEB_DETAILS = () => async (dispatch, getState) => {
  try {
    dispatch({ type: UNIVERSITY_WEB_DETAILS_LIST_REQ });
    const { LoginReducer } = getState();
    let { data } = await axiosConfig.get(`/universityDetails`);
    if (data?.Result.includes("Error")) {
      dispatch({
        type: UNIVERSITY_WEB_DETAILS_LIST_FAILED,
        payload: data.Result,
      });
    } else {
      dispatch({
        type: UNIVERSITY_WEB_DETAILS_LIST_SUCCESS,
        payload: data.Result,
      });
    }
  } catch (ex) {
    dispatch({
      type: UNIVERSITY_WEB_DETAILS_LIST_FAILED,
      payload: `Error-${ex.message}`,
    });
  }
};

export const CREATE_UNIVERSITY_WEB_DETAILS =
  (form_data) => async (dispatch, getState) => {
    try {
      dispatch({ type: CREATE_UNIVERSITY_WEB_DETAILS_REQ });

      const { LoginReducer } = getState();
      let { data } = await axiosConfig.post(`/universityDetails`, form_data);
      if (data.Result.includes("Error")) {
        dispatch({
          type: CREATE_UNIVERSITY_WEB_DETAILS_FAILED,
          payload: data.Result,
        });
      } else {
        dispatch({
          type: CREATE_UNIVERSITY_WEB_DETAILS_SUCCESS,
          payload: data.Result,
        });
      }
    } catch (ex) {
      dispatch({
        type: CREATE_UNIVERSITY_WEB_DETAILS_FAILED,
        payload: `Error-${ex.message}`,
      });
    }
  };

export const UNIVERSITY_WEB_DETAILS_CREATE_RESET = () => (dispatch) => {
  dispatch({ type: CREATE_UNIVERSITY_WEB_DETAILS_RESET });
};

export const UNIVERSITY_WEB_DETAILS_UPDATE =
  (university_WEB_data) => async (dispatch, getState) => {
    try {
      dispatch({ type: UPDATE_UNIVERSITY_WEB_DETAILS_REQ });
      const { LoginReducer } = getState();
      let { data } = await axiosConfig.put(
        `/universityDetails`,
        university_WEB_data
      );
      if (data.Result.includes("Error")) {
        dispatch({
          type: UPDATE_UNIVERSITY_WEB_DETAILS_FAILED,
          payload: data.Result,
        });
      } else {
        dispatch({
          type: UPDATE_UNIVERSITY_WEB_DETAILS_SUCCESS,
          payload: data.Result,
        });
      }
    } catch (ex) {
      dispatch({
        type: UPDATE_UNIVERSITY_WEB_DETAILS_FAILED,
        payload: `Error-${ex.message}`,
      });
    }
  };

export const UNIVERSITY_WEB_DETAILS_UPDATE_RESET = () => (dispatch) => {
  dispatch({ type: UPDATE_UNIVERSITY_WEB_DETAILS_RESET });
};

export const UNIVERSITY_WEB_DETAILS_DELETE =
  (ID) => async (dispatch, getState) => {
    try {
      dispatch({ type: DELETE_UNIVERSITY_WEB_DETAILS_REQ });
      let { data } = await axiosConfig.delete(`/universityDetails/${ID}`);
      if (data.Result.includes("Error")) {
        dispatch({
          type: DELETE_UNIVERSITY_WEB_DETAILS_FAILED,
          payload: data.Result,
        });
      } else {
        dispatch({
          type: DELETE_UNIVERSITY_WEB_DETAILS_SUCCESS,
          payload: data.Result,
        });
      }
    } catch (ex) {
      dispatch({
        type: DELETE_UNIVERSITY_WEB_DETAILS_FAILED,
        payload: `Error-${ex.message}`,
      });
    }
  };

export const UNIVERSITY_WEB_DETAILS_DELETE_RESET = () => (dispatch) => {
  dispatch({ type: DELETE_UNIVERSITY_WEB_DETAILS_RESET });
};

export const UNIVERSITYWEB_DETAILS_SINGLE_DATA =
  (ID) => async (dispatch, getState) => {
    try {
      dispatch({ type: UNIVERSITY_WEB_DETAILS_SINGLE_REQ });
      let { data } = await axiosConfig.get(`/universityDetails/${ID}`);
      if (data.includes("Error")) {
        dispatch({
          type: UNIVERSITY_WEB_DETAILS_SINGLE_FAILED,
          payload: data.result,
        });
      } else {
        dispatch({
          type: UNIVERSITY_WEB_DETAILS_SINGLE_SUCCESS,
          payload: data.result,
        });
      }
    } catch (ex) {
      dispatch({
        type: UNIVERSITY_WEB_DETAILS_SINGLE_FAILED,
        payload: `Error-${ex.message}`,
      });
    }
  };
